import { TabItem, TabList, Tabs } from "../../../../core/Tabs.js";
import type { ForgeSort, ForgeSortContent } from "../../forgeContent.js";

/** Newest or most opened: a named tab list over the grid. */
export function ForgeSortTabs({ value, label, options, onValueChange }: ForgeSortContent) {
  return (
    <Tabs value={value} onValueChange={(next) => onValueChange(next as ForgeSort)}>
      <TabList aria-label={label}>
        {options.map((option) => (
          <TabItem key={option.value} value={option.value}>
            {option.label}
          </TabItem>
        ))}
      </TabList>
    </Tabs>
  );
}
